// Please: Alphabetize the exports

export const ADHOC_EVENT_TYPE = 'AdhocEventType'
export const MANAGED_EVENT_TYPE = 'ManagedEventType'
export const STANDARD_EVENT_TYPE = 'StandardEventType'

export const EVENT_TYPE_LIST_TAGS = [
  'EVENT_TYPE_LIST',
  'PROFILE_EVENT_TYPE_LIST',
  'EVENT_TYPES_COLLECTION',
  'MEETING_TYPES_LIST',
  'PROFILE_MEETING_TYPES_LIST',
  'WIZARD_METADATA'
]

export const SCHEDULING_FETCH_EVENT_TYPES = 'schedulingFetchEventTypes'
export const FETCH_EVENT_TYPES = 'fetchEventTypes'
export const FETCH_EVENT_TYPE = 'fetchEventType'
export const FETCH_PROFILES = 'fetchProfiles'

export const EVENT_TYPES_LIST_ITEM_ATTRIBUTES = [
  'id',
  'uuid',
  'uri',
  'kind',
  'type',
  'created_via',
  'pooling_type',
  'name',
  'slug',
  'description',
  'duration',
  'duration_minutes',
  'duration_options',
  'position',
  'color',
  'active',
  'public',
  'internal_note',
  'booking_url',
  'booking_path',
  'edit_path',
  'api_clone_path',
  'policy',
  'kind_description',
  'kind_name',
  'location_type',
  'location_types_count',
  'lock_timezone_enabled',
  'lock_timezone_content',
  'availability_timezone',
  'profile_id',
  'owner_type',
  'multi_publisher',
  'owner_id',
  'locale',
  'has_active_payment_method',
  'payment',
  'payment_provider',
  'has_sms_notification',
  'invitees_limit',
  'parent_id',
  'is_user_group_managed',
  'ignore_location_configurations',
  'available_locales',
  'memberships',
  'location_configurations'
]
